import classNames from 'classnames';
import PropTypes from 'prop-types';
import { MFLazyLoad } from '@medifind/shared-basic-components';
import { Button } from '@medifind/shared-basic-components';
import styles from './FilterSideContainer.module.scss';

const FilterSideContainer = ({ children, clearFilters, title, lazyLoadOptions, className, classes = {} }) => {
  return (
    <div className={classNames(styles['container'], className)}>
      <h2 className={classNames(styles['header'], classes.header)}>{title}</h2>
      <div className={styles['header--curve']}></div>
      <div className={styles['body']}>
        <MFLazyLoad {...lazyLoadOptions}>{children}</MFLazyLoad>
      </div>
      {clearFilters && (
        <div className={styles['buttons-wrapper']}>
          <Button focus={'underline'} color={'thin-grey-border'} label="Reset all" type="thin" onClick={clearFilters} />
        </div>
      )}
    </div>
  );
};

FilterSideContainer.propTypes = {
  children: PropTypes.any,
  lazyLoadOptions: PropTypes.object.isRequired,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  classes: PropTypes.object,
  clearFilters: PropTypes.func,
};

export { FilterSideContainer as default, FilterSideContainer };
